import React, { useRef, useState, useEffect } from 'react';
import { Button, Col, Collapse, Layout, Row } from 'antd';
import { ReactComponent as Sbgrowth } from '../../../assets/icons/bg-funding1.svg';
import { ReactComponent as AICoe } from '../../../assets/icons/laptop2.svg';
import { useNavigate, useLocation } from 'react-router-dom';

const { Content } = Layout;
const { Panel } = Collapse;

const LandingPage = () => {
  const [activeKey, setActiveKey] = useState();
  const navigate = useNavigate();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  return (
    <Layout id="landing-page">
      <Content>
        <div className="landing-layout">
          <div className="landing-first-quarter">
            <div className="hero-section">
              <Sbgrowth className="background-svg" />

              {/* Foreground content */}
              <div className="hero-content">
                <p className="funding">Funding Advisor</p>
                <p className="first-text">
                  Η χρηματοδότηση που ψάχνεις σχεδιασμένη για εσένα
                </p>
                <p className="second-text">
                  Αξιοποίησε τη δύναμη του AI για να ανακαλύψεις το κατάλληλο πρόγραμμα ενίσχυσης 
                  για την επιχείρησή σου και δημιούργησε σε λίγα λεπτά το πλήρες, εξατομικευμένο 
                  επενδυτικό σου σχέδιο.

                </p>
                <p className="second-text">
                  Ξέχνα τις πολύπλοκες διαδικασίες, εμπιστεύσου τον AI σύμβουλο και επένδυσε 
                  στην επιχείρησή σου με ασφάλεια και προοπτική!
                </p>
                <div className="buttons-wrapper">
                  <Button
                    onClick={() => navigate('/register')}
                    className="left-button"
                    id="static-btn"
                  >
                    <span className="left-button-span">Θέλω να εγγραφώ</span>
                  </Button>
                  <Button
                    onClick={() => navigate('/loginAs')}
                    className="right-button"
                    id="static-btn"
                  >
                    <span className="right-button-span">
                      Είσοδος στην πλατφόρμα
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="main-container">
              <div className="landing-second-quarter">
                <div className="second-quarter-texts">
                  <span className="second-quarter-second-text mt-9">
                    Πως λειτουργεί
                  </span>
                  <span className="second-quarter-third-text mb-2">
                    4 απλά βήματα για να πας την επιχείρησή σου στο επόμενο επίπεδο
                  </span>
                </div>
                <div className="steps-row">
                  <div className="gradient-line" />

                  <Col>
                    <div className="step-content-header mb-2">1</div>

                    <div className="step-container">
                      <div className="step-content-wrapper">
                        <div className="step-content">
                          <span className="step-content-text">
                            Εγγραφή στην πλατφόρμα
                          </span>
                          <div className="step-content-subtext">
                            Κάνε την εγγραφή σου, συμπλήρωσε τα στοιχεία σου και ένας 
                            εκπρόσωπός μας θα σε καθοδηγήσει άμεσα.<br /><br />
                            Δημιούργησε τον προσωπικό σου λογαριασμό και επίλεξε τη συνδρομή 
                            που ταιριάζει στις ανάγκες της επιχείρησής σου.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="step-content-header mb-2">2</div>

                    <div className="step-container">
                      <div className="step-content-wrapper">
                        <div className="step-content">
                          <span className="step-content-text">
                            Είσοδος και συμπλήρωση στοιχείων
                          </span>
                          <div className="step-content-subtext">
                            Συνδέσου στην πλατφόρμα με τους κωδικούς σου και 
                            εισήγαγε τα βασικά στοιχεία της επιχείρησής σου.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="step-content-header mb-2">3</div>

                    <div className="step-container">
                      <div className="step-content-wrapper">
                        <div className="step-content">
                          <span className="step-content-text">
                            Εξατομικευμένες προτάσεις χρηματοδότησης
                          </span>
                          <div className="step-content-subtext">
                            Παρουσίασε την επένδυσή σου στον AI σύμβουλο και 
                            λάβε άμεσα στοχευμένες προτάσεις.<br /><br />
                            Ο AI σύμβουλος αναλύει την επένδυσή σου και ξεχωρίζει για εσένα τις 
                            βέλτιστες χρηματοδοτικές ευκαιρίες—άμεσα, εξατομικευμένα και με ακρίβεια!
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="step-content-header mb-2">4</div>

                    <div className="step-container">
                      <div className="step-content-wrapper">
                        <div className="step-content">
                          <span className="step-content-text">
                            Δημιουργία Επενδυτικού Σχεδίου
                          </span>
                          <div className="step-content-subtext">
                            Επέλεξε το πρόγραμμα (/ή το συνδυασμό προγραμμάτων) ενίσχυσης 
                            και το χρηματοδοτικό σχήμα που σου ταιριάζει.<br /><br />
                            Ο AI σύμβουλος δημιουργεί πλήρες, δομημένο και προσαρμοσμένο στις  
                            απαιτήσεις του προγράμματος Επενδυτικό Σχέδιο, έτοιμο προς υποβολή.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </div>
            </div>

            <Row className="landing-third-quarter main-container flex-column justify-content-center">
              <div className="landing-third-quarter-title justify-content-center">
                Τι Κερδίζω;
              </div>
              <div className="landing-third-quarter-subtitle justify-content-center mt-2">
                Ποια είναι τα οφέλη για την επιχείρησή σου;
              </div>
            </Row>
            <Row className="landing-third-quarter main-container">
              <Col className="first-landing-column">
                <div style={{ maxWidth: '450px' }}>
                  <AICoe style={{ width: '100%', height: 'auto' }}></AICoe>
                </div>
              </Col>

              <Col>
                <div>
                  <div className="landing-column">
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Στοχευμένη εύρεση προγραμμάτων
                        </label>
                      </div>
                      <p className="columns-content">
                        Η πλατφόρμα αξιολογεί τα δεδομένα και τις ανάγκες της επιχείρησής σου και 
                        εντοπίζει όλα τα ενεργά προγράμματα ενίσχυσης που ταιριάζουν στο επενδυτικό 
                        σου προφίλ και τις προτεραιότητές σου.
                      </p>
                    </div>
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Βέλτιστες προτάσεις ενίσχυσης
                        </label>
                      </div>
                      <p className="columns-content">
                        Με βάση τις ανάγκες και το σχέδιό σου, λαμβάνεις εξατομικευμένες προτάσεις που 
                        μεγιστοποιούν τις πιθανότητες έγκρισης και επιτυχίας κάθε επένδυσης.
                      </p>
                    </div>
                  </div>
                  <div className="landing-column">
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Άμεση δημιουργία επενδυτικού σχεδίου
                        </label>
                      </div>
                      <p className="columns-content">
                        Ο AI σύμβουλος δημιουργεί για εσένα ένα πλήρες, 
                        δομημένο και έτοιμο προς υποβολή επενδυτικό σχέδιο, 
                        προσαρμοσμένο στις απαιτήσεις του κάθε προγράμματος.
                      </p>
                    </div>
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Υψηλή ασφάλεια και εμπιστευτικότητα
                        </label>
                      </div>
                      <p className="columns-content">
                        Κάθε πληροφορία που εισάγεις προστατεύεται με σύγχρονα πρωτόκολλα κρυπτογράφησης και
                         συμμορφώνεται με το GDPR και τους σχετικούς κανονισμούς ασφάλειας δεδομένων, 
                         εξασφαλίζοντας ότι η διαχείριση των δεδομένων σου γίνεται με ασφάλεια και απόλυτη διακριτικότητα.
                      </p>
                    </div>
                  </div>
                  <div className="landing-column mt-14">
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Συνδρομή με υψηλή απόδοση αξίας
                        </label>
                      </div>
                      <p className="columns-content">
                        Με μία προσιτή συνδρομή αποκτάς πρόσβαση σε τεχνολογία, συμβουλευτική και 
                        αυτοματοποίηση που μειώνουν σημαντικά κόστος και λάθη, ενώ ενισχύουν την 
                        αποτελεσματικότητα και την πιθανότητα εύρεσης χρηματοδότησης.
                      </p>
                    </div>
                    <div className="landing-column-content">
                      <div className="column-labels-wrapper">
                        <label className="columns-label">
                          Εξοικονόμηση χρόνου και ταχύτητα στην υλοποίηση
                        </label>
                      </div>
                      <p className="columns-content">
                        Η πλατφόρμα επιταχύνει κάθε βήμα της διαδικασίας, από την επιλογή προγράμματος 
                        μέχρι την ολοκλήρωση του επενδυτικού σχεδίου, επιτρέποντάς σου να επικεντρωθείς 
                        στην ανάπτυξη της επιχείρησής σου.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="grey-wrapper mt-5">
              <div className="landing-fourth-quarter">
                <div className="collapse-texts-wrapper">
                  <div className="collapse-text">
                    <text className="collapse-first-text">
                      Συχνές Ερωτήσεις
                    </text>
                  </div>
                  <div className="collapse-text ">
                    <text className="collapse-second-text">
                      Όλα όσα πρέπει να γνωρίζετε για την διαδικασία
                    </text>
                  </div>
                </div>
                <div id="landing-info">
                  <Collapse
                    key="1"
                    className="main-content__collapse"
                    // expandIcon={({ isActive }) =>
                    //   isActive ? <Minus /> : <Plus />
                    // }
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '1' ? setActiveKey('') : setActiveKey('1')
                    }
                    activeKey={activeKey}
                  >
                    {/* <Panel
                    header={
                      <text className='panel-header-title'>
                        Όλα όσα πρέπει να γνωρίζετε για τη διαδικασία
                      </text>
                    }
                    key="1"
                  >
                    <div>
                      <p>
                        Το Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»
                        επιχορηγεί νοικοκυριά για την αντικατάσταση ενεργοβόρων
                        ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας
                        ηλιακούς θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.
                        Το πρόγραμμα περιλαμβάνει:
                      </p>
                    </div>
                  </Panel> */}
                  </Collapse>

                  <Collapse
                    key="2"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '2'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '2' ? setActiveKey('') : setActiveKey('2')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Ποιος είναι ο σκοπός της πλατφόρμας;
                        </text>
                      }
                      key="2"
                    >
                      <div>
                        <p>
                          Η πλατφόρμα βοηθά επιχειρήσεις να εντοπίσουν τα κατάλληλα προγράμματα χρηματοδότησης 
                          και να δημιουργήσουν γρήγορα, εύκολα και επαγγελματικά τα επενδυτικά τους σχέδια, 
                          αξιοποιώντας τεχνολογία AI.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="3"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '3'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '3' ? setActiveKey('') : setActiveKey('3')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Ποιο είναι το αντικείμενο της πλατφόρμας;
                        </text>
                      }
                      key="3"
                    >
                      <div>
                        <p>
                          Ο αλγόριθμος αναλύει τα στοιχεία της επιχείρησής σας, ελέγχει επιλεξιμότητα, 
                          εντοπίζει όλα τα προγράμματα που ταιριάζουν στο επενδυτικό σας προφίλ και δημιουργεί 
                          αυτοματοποιημένα επενδυτικά σχέδια προσαρμοσμένα στις απαιτήσεις κάθε προγράμματος.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="4"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '4'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '4' ? setActiveKey('') : setActiveKey('4')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Πώς λειτουργεί η πλατφόρμα;
                        </text>
                      }
                      key="4"
                    >
                      <div>
                        <p>
                          Η διαδικασία ολοκληρώνεται σε τέσσερα βήματα:
                          <ol>
                            <li>
                              Εγγραφή & επιλογή συνδρομής
                            </li>
                            <li>
                              Υποβολή στοιχείων επιχείρησης & επένδυσης
                            </li>
                            <li>
                              Αυτοματοποιημένες προτάσεις χρηματοδότησης
                            </li>
                            <li>
                              Δημιουργία έτοιμου επενδυτικού σχεδίου (ανάλογα με το πακέτο συνδρομής)
                            </li>
                          </ol>
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="5"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '5'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '5' ? setActiveKey('') : setActiveKey('5')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Ποια στοιχεία χρειάζονται για να λάβω προτάσεις;
                        </text>
                      }
                      key="5"
                    >
                      <div>
                        <p>
                          Θα χρειαστείτε γενικά στοιχεία της επιχείρησης, ΚΑΔ / δραστηριότητα, τοποθεσία επένδυσης, προϋπολογισμό και βασικές δαπάνες καθώς και μια σύντομη περιγραφή του έργου.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="6"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '6'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '6' ? setActiveKey('') : setActiveKey('6')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Τι είδους επενδυτικά σχέδια μπορεί να παράγει το σύστημα;
                        </text>
                      }
                      key="6"
                    >
                      <div>
                        <p>
                          Ο AI σύμβουλος μπορεί να δημιουργήσει οποιοδήποτε τύπο επενδυτικού σχεδίου, για όλους τους τομείς.
                        </p>
                        <p>
                          Ο αλγόριθμος προσαρμόζει το επενδυτικό σας σχέδιο στις απαιτήσεις του επιλεγμένου προγράμματος ενίσχυσης, 
                          ώστε να ταιριάζει πλήρως με τους όρους και τις προϋποθέσεις.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="7"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '7'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '7' ? setActiveKey('') : setActiveKey('7')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Μπορώ να αλλάξω συνδρομή οποιαδήποτε στιγμή;
                        </text>
                      }
                      key="7"
                    >
                      <div>
                        <p>
                          Μπορείτε να αναβαθμίσετε τη συνδρομή σας ανά πάσα στιγμή.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="8"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '8'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '8' ? setActiveKey('') : setActiveKey('8')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Πώς προστατεύονται τα δεδομένα μου;
                        </text>
                      }
                      key="8"
                    >
                      <div>
                        <p>
                          Η πλατφόρμα εφαρμόζει κρυπτογράφηση end-to-end, συμμόρφωση GDPR, ασφαλή servers, role-based access control και τακτικούς ελέγχους ασφαλείας.
                        </p>
                        <p>
                          Τα δεδομένα δεν κοινοποιούνται σε τρίτους χωρίς συναίνεσή σας.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="9"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '9'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '9' ? setActiveKey('') : setActiveKey('9')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Τι υποστήριξη παρέχετε;
                        </text>
                      }
                      key="9"
                    >
                      <div>
                        <p>
                        Η ομάδα υποστήριξης παρέχει τεχνική βοήθεια, καθοδήγηση στη χρήση της πλατφόρμας, 
                        απαντήσεις σε ερωτήσεις χρηματοδότησης και βοήθεια για τη δημιουργία επενδυτικού σχεδίου.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="10"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '10'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '10' ? setActiveKey('') : setActiveKey('10')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Τι γίνεται αν αλλάξω τα δεδομένα της επένδυσης;
                        </text>
                      }
                      key="10"
                    >
                      <div>
                        <p>
                        Πριν επιλέξετε το πεδίο «Υποβολή», μπορείτε να τροποποιείτε ελεύθερα το επενδυτικό σας σχέδιο όσες φορές θέλετε χωρίς καμία δέσμευση slot - η πλατφόρμα βρίσκεται στο στάδιο προετοιμασίας.
                        </p>
                        <p>
                          Όταν πατήσετε «Υποβολή», δεσμεύεται 1 slot από τα διαθέσιμα της συνδρομής σας και ο AI σύμβουλος πραγματοποιεί τελική ανάλυση και ξεκινά η διαδικασία ανεύρεσης/ελέγχου. 
                        </p>
                        <p>
                          Από εκείνο το σημείο και μετά για νέες επανεξετάσεις ή νέα σενάρια επένδυσης απαιτείται νέο slot, ανάλογα με το πακέτο συνδρομής.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="11"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '11'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '11' ? setActiveKey('') : setActiveKey('11')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Σε πόσο χρόνο παίρνω προτάσεις χρηματοδότησης;
                        </text>
                      }
                      key="11"
                    >
                      <div>
                        <p>
                          Εντός λίγων δευτερολέπτων.
                        </p>
                        <p>
                          Το επενδυτικό σχέδιο δημιουργείται μέσα σε λίγα λεπτά.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="12"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '12'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '12' ? setActiveKey('') : setActiveKey('12')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Ποιος έχει πρόσβαση στα επενδυτικά μου σχέδια;
                        </text>
                      }
                      key="12"
                    >
                      <div>
                        <p>
                          Μόνο εσείς και η ομάδα υποστήριξης (αν ζητήσετε βοήθεια).
                        </p>
                        <p>
                          Κανένας τρίτος φορέας δεν έχει πρόσβαση.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>

                  <Collapse
                    key="13"
                    className={
                      'main-content__collapse ' +
                      (activeKey === '13'
                        ? 'border-collapse-open'
                        : 'border-collapse-closed')
                    }
                    expandIcon={() => null}
                    expandIconPosition={'right'}
                    onChange={e =>
                      activeKey === '13' ? setActiveKey('') : setActiveKey('13')
                    }
                    activeKey={activeKey}
                  >
                    <Panel
                      header={
                        <text className="panel-header-title">
                          Τι χρειάζεται για να ξεκινήσω;
                        </text>
                      }
                      key="13"
                    >
                      <div>
                        <p>
                          Μόνο το email σας, βασικά εταιρικά στοιχεία και επιλογή συνδρομής.
                        </p>
                        <p>
                          Η διαδικασία διαρκεί λιγότερο από 2 λεπτά.
                        </p>
                      </div>
                    </Panel>
                  </Collapse>
        
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default LandingPage;
